"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONFIGURATION_KEYS = exports.BurndownSeriesType = void 0;
const _1 = require(".");
const baseName = "dashboard";
var BurndownSeriesType;
(function (BurndownSeriesType) {
    BurndownSeriesType["CARRY_OVER"] = "CARRY_OVER";
    BurndownSeriesType["REMOVED"] = "REMOVED";
    BurndownSeriesType["FINISHED"] = "FINISHED";
})(BurndownSeriesType = exports.BurndownSeriesType || (exports.BurndownSeriesType = {}));
exports.CONFIGURATION_KEYS = {
    analytics: {
        charts: {
            list: {
                name: `${baseName}.analytics.charts.list`,
                chain: [_1.ConfigurationEntityType.Team, _1.ConfigurationEntityType.DataContributor],
                type: {}
            }
        }
    },
    user: {
        flags: {
            name: `${baseName}.user.flags`,
            chain: [_1.ConfigurationEntityType.Team, _1.ConfigurationEntityType.DataContributor],
            type: {}
        }
    },
    burndown: {
        series: {
            name: `${baseName}.burndown.series`,
            chain: [_1.ConfigurationEntityType.Team, _1.ConfigurationEntityType.DataContributor],
            type: {}
        },
        drillDown: {
            name: `${baseName}.burndown.drillDown`,
            chain: [_1.ConfigurationEntityType.Team],
            type: {}
        }
    }
};
//# sourceMappingURL=dashboard.js.map